import { render } from 'preact';
import '@fontsource/ibm-plex-mono/latin-400.css';
import '@fontsource/ibm-plex-mono/latin-700.css';
import '@fontsource/ibm-plex-sans/latin-400.css';
import '@fontsource/ibm-plex-sans/latin-600.css';
import './ui/styles.css';
import { App } from './ui/app';
import { watchSystemTheme } from './ui/theme';

watchSystemTheme();
const root = document.getElementById('app');
if (root) render(<App />, root);
